export const productDetailsFields = [
  'maxOrderQuantity',
  'productsDesignedFor(name,commercialCode,sisCategory)',
  'isAccessory',
  'onSale',
  'ecoTaxPrice(formattedValue,value)',
  'freeEditorialLocal',
  'freeEditorialBU',
  'star',
  'whatIsInBox',
  'standardImage(FULL)',
  'commercialCode',
  'externalLogistician',
  'newProduct',
  'averageRating',
  'bestSeller',
  'categories',
  'claim',
  'classifications(FULL)',
  'code',
  'description',
  'descriptionImages',
  'discountedPrice',
  'faqs',
  'formattedDiscountValue',
  'images(FULL)',
  'instructionsForUse',
  'name',
  'productBenefits(FULL)',
  'productReferences',
  'promoMessage',
  'promoMessageEnabled',
  'price(FULL)',
  'shortDescription',
  'ssEditorialDescriptionDetail',
  'ssEditorialDescriptionTitle',
  'stock(FULL)',
  'topBenefits(BASIC)',
  'updateEditorial',
  'url',
  'reparabilityIncluded',
  'repairabilityStatus',
  'benefitHighLights',
  'bundles(name,price,galleryImages(FULL),canonicalURL, saved, discountedPrice, claim, id, products(price(value),onSale,stock(stockLevelStatus)))',
  'howTo',
  'uspDisclaimer',
  'keyClaimDisclaimer',
  'cmmfOtherDisclaimers',
  'showChat',
  'liveChatAgentConfig(FULL)',
  'topCategoryName',
  'subCategoryName',
  'sisCategory',
  'sisSubCategory',
  'accessoryCategorisation',
  'productGenre',
  'shippingIncluded',
  'repairabilityIndex(FULL)',
  'updateBenefitHighlights',
  'updateShortEditorial',
  'gsebAverageRating',
  'gsebNumberOfReviews',
  'superCategoryMarketingName',
  'isMarketing',
  'urlCsp',
  'urlIfu',
  'displayExternalRatingAndReviewsWidget',
  'replacedBy',
  'replacementProductURL',
  'agecLaw',
  'badges',
  'brand',
  'potentialPromotions',
  'afterSalesServiceReferences',
  'familyAnneeN',
  'family2',
  'descriptionTag',
  'fallbackURL'
];
